import React, { useState } from 'react';
import { Joyride, STATUS } from 'react-joyride';

const tutorialSteps = [
  {
    target: '[data-testid="nav-dashboard"]',
    content: 'Welcome to PeptideForge! Start here to see your overview, stats, and today\'s schedule.',
    placement: 'right'
  },
  {
    target: '[data-testid="nav-calculator"]',
    content: 'The Calculator is your most important tool - use it to calculate precise reconstitution doses and syringe units.',
    placement: 'right'
  },
  {
    target: '[data-testid="nav-peptides"]',
    content: 'Browse 20+ pre-loaded peptides with detailed research information, or add your own custom peptides (Premium).',
    placement: 'right'
  },
  {
    target: '[data-testid="nav-inventory"]',
    content: 'Track your vials with batch numbers, expiry dates, and costs. Get low-stock alerts automatically.',
    placement: 'right'
  },
  {
    target: '[data-testid="nav-logs"]',
    content: 'Log every dose with details like injection site, side effects, and notes. Export your data anytime.',
    placement: 'right'
  },
  {
    target: '[data-testid="nav-analytics"]',
    content: 'Premium members get advanced analytics: adherence rates, dose consistency, cost optimization, and AI insights.',
    placement: 'right'
  },
  {
    target: '[data-testid="theme-toggle-button"]',
    content: 'Toggle between dark and light modes anytime from here.',
    placement: 'top'
  },
  {
    target: '[data-testid="disclaimer-banner"]',
    content: 'Important: All data is for research purposes only. Always verify COAs and comply with local laws.',
    placement: 'bottom'
  }
];

export default function AppTutorial({ run, onComplete }) {
  const [stepIndex, setStepIndex] = useState(0);

  const handleJoyrideCallback = (data) => {
    const { status, index, type } = data;

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Mark tutorial as completed
      localStorage.setItem('peptideforge_tutorial_completed', 'true');
      if (onComplete) onComplete();
    }

    if (type === 'step:after') {
      setStepIndex(index + 1);
    }
  };

  return (
    <Joyride
      steps={tutorialSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      disableScrolling={false}
      disableOverlayClose={false}
      stepIndex={stepIndex}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#3B82F6',
          backgroundColor: '#18181B',
          textColor: '#F4F4F5',
          arrowColor: '#18181B',
          overlayColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: '12px',
          padding: '20px',
        },
        buttonNext: {
          backgroundColor: '#3B82F6',
          borderRadius: '8px',
          padding: '10px 20px',
        },
        buttonBack: {
          color: '#A1A1AA',
          marginRight: '10px',
        },
        buttonSkip: {
          color: '#F87171',
        }
      }}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Finish',
        next: 'Next',
        skip: 'Skip Tutorial'
      }}
    />
  );
}
